import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, Plus } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

export default function ReviewsAdminPage() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ customer_name: "", vehicle_purchased: "", rating: 5, review: "", photo: "" });
  const load = () => api.get("/reviews").then((r) => setItems(r.data.items));
  useEffect(() => { load(); }, []);
  const add = async (e) => {
    e.preventDefault();
    try { await api.post("/reviews", form); setForm({ customer_name: "", vehicle_purchased: "", rating: 5, review: "", photo: "" }); toast.success("Added"); load(); }
    catch (err) { toast.error(formatApiError(err)); }
  };
  const del = async (id) => { if (!window.confirm("Delete?")) return; await api.delete(`/reviews/${id}`); load(); };
  return (
    <div className="space-y-5" data-testid="admin-reviews-page">
      <h1 className="font-display font-extrabold text-2xl text-gray-900">Reviews ({items.length})</h1>
      <form onSubmit={add} className="bg-white rounded-xl border border-gray-200 p-5 grid grid-cols-1 md:grid-cols-2 gap-3">
        <input placeholder="Customer name" required value={form.customer_name} onChange={(e) => setForm({ ...form, customer_name: e.target.value })} className="rounded-md border border-gray-200 px-3 py-2 text-sm" />
        <input placeholder="Vehicle purchased (optional)" value={form.vehicle_purchased} onChange={(e) => setForm({ ...form, vehicle_purchased: e.target.value })} className="rounded-md border border-gray-200 px-3 py-2 text-sm" />
        <select value={form.rating} onChange={(e) => setForm({ ...form, rating: Number(e.target.value) })} className="rounded-md border border-gray-200 px-3 py-2 text-sm">{[5, 4, 3, 2, 1].map((n) => <option key={n}>{n}</option>)}</select>
        <input placeholder="Customer photo URL (optional)" value={form.photo} onChange={(e) => setForm({ ...form, photo: e.target.value })} className="rounded-md border border-gray-200 px-3 py-2 text-sm" />
        <textarea placeholder="Review text" required value={form.review} onChange={(e) => setForm({ ...form, review: e.target.value })} rows={3} className="md:col-span-2 rounded-md border border-gray-200 px-3 py-2 text-sm" />
        <button className="btn-primary md:col-span-2"><Plus size={14} /> Add Review</button>
      </form>
      <div className="space-y-2">
        {items.map((r) => (
          <div key={r.id} className="bg-white rounded-xl border border-gray-200 p-4 flex justify-between gap-3">
            <div><div className="font-bold">{r.customer_name} · {r.rating}★</div><div className="text-xs text-gray-500">{r.vehicle_purchased}</div><p className="text-sm text-gray-700 mt-1">{r.review}</p></div>
            <button onClick={() => del(r.id)} className="text-red-600 shrink-0"><Trash2 size={14} /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
